import { Avatar, Box, Button, Tooltip, Typography } from "@mui/material";
import FilterDMLOAIXE from "../components/common/filters/dmloaixe/FilterDMLOAIXE";
import FilterDMNHAXE from "../components/common/filters/dmnhaxe/FilterDMNHAXE";
import FilterDMXE from "../components/common/filters/dmxe/FilterDMXE";
import FilterHangVeXe from "../components/common/filters/hangvexe/FilterHangVeXe";
import FilterRoute from "../components/common/filters/route/FilterRoute";
import FormDMLOAIXE from "../components/common/form/dmloaixe/FormDMLOAIXE";
import FormDMNHAXE from "../components/common/form/dmnhaxe/FormDMNHAXE";
import FormDMXE from "../components/common/form/dmxe/FormDMXE";
import FormHangVeXe from "../components/common/form/hangvexe/FormHangVeXe";
import FormRoute from "../components/common/form/route/FormRoute";
import FormTicketOrder from "../components/common/form/ticketorder/FormTicketOrder";
import { CategoryType } from "../types/category.type";
import { formatDateDisplay, generateLinkImage, numeralCustom } from "./helpers";
import FilterTicketOrder from "../components/common/filters/ticketorder/FilterTicketOrder";
import FormHangHoa from "../components/common/form/hanghoa/FormHangHoa";
import ExpandHangHoa from "../components/common/expand/hanghoa/ExpandHangHoa";
import FormNhomHang from "../components/common/form/nhomhang/FormNhomHang";
import FormDMQDDVT from "../components/common/form/dmqddvt/FormDMQDDVT";
import FormCDVT from "../components/common/form/cdvt/FormCDVT";
import FormPKK from "../components/common/form/pkk/FormPKK";
import ExpandPBL from "../components/common/expand/pbl/ExpandPBL";
import ExpandPkk from "../components/common/expand/pkk/ExpandPkk";
import FormHD7 from "../components/common/form/hd7/FormHD7";
import ExpandHD7 from "../components/common/expand/hd7/ExpandHD7";
import FormPN1 from "../components/common/form/pn1/FormPN1";
import ExpandPN1 from "../components/common/expand/pn1/ExpandPN1";
import FormPN5 from "../components/common/form/pn5/FormPN5";
import ExpandPN5 from "../components/common/expand/pn5/ExpandPN5";
import ExpandPXK from "../components/common/expand/pxk/ExpandPXK";
import FormPXK from "../components/common/form/pxk/FormPXK";
import FormPT1 from "../components/common/form/pt1/FormPT1";
import ExpandPT1 from "../components/common/expand/pt1/ExpandPT1";
import FormPC1 from "../components/common/form/pc1/FormPC1";
import ExpandPC1 from "../components/common/expand/pc1/ExpandPC1";
import FormMonAn from "../components/common/form/monan/FormMonAn";
import ExpandMonAn from "../components/common/expand/monan/ExpandMonAn";
import FormNhomMon from "../components/common/form/nhommon/FormNhomMon";
import FormPBLNH from "../components/common/form/pbl_nh/FormPBLNH";
import ExpandPBLNH from "../components/common/expand/pbl_nh/ExpandPBLNH";
import FormDMBAN from "../components/common/form/dmban/FormDMBAN";
import FormNHOMBAN from "../components/common/form/nhomban/FormNHOMBAN";
import FormCustomer from "../components/common/form/customer/FormCustomer";
import FormDMNHKH from "../components/common/form/dmnhkh/FormDMNHKH";
import FormNCC from "../components/common/form/ncc/FormNCC";
import FormDMNHNCC from "../components/common/form/dmnhncc/FormDMNHNCC";
import FormUsergroup from "../components/common/form/usergroup/FormUsergroup";
import ExpandUsergroup from "../components/common/expand/usergroup/ExpandUsegroup";
import FormParticipant from "../components/common/form/participant/FormParticipant";
import CheckboxInput from "../components/common/input/CheckboxInput";
import FormDMDVT from "../components/common/form/dmdvt/FormDMDVT";
import FormDmKho from "../components/common/form/dmkho/FormDmkho";
import FilterHangHoa from "../components/common/filters/hanghoa/FilterHangHoa";
import FilterNhomHang from "../components/common/filters/nhomhang/FilterNhomHang";
import FilterDMQDDVT from "../components/common/filters/dmqddvt/FilterDMQDDVT";
import FilterCDVT from "../components/common/filters/cdvt/FilterCDVT";
import FilterPKK from "../components/common/filters/pkk/FilterPKK";
import { LuPlusCircle } from "react-icons/lu";
import { Link } from "react-router-dom";
import FilterPBL from "../components/common/filters/pbl/FilterPBL";
import FilterHD7 from "../components/common/filters/hd7/FilterHd7";
import FilterPN1 from "../components/common/filters/pn1/FilterPN1";
import FilterPN5 from "../components/common/filters/pn5/FilterPN5";
import FilterPXK from "../components/common/filters/pxk/FilterPXK";
import FilterPT1 from "../components/common/filters/pt1/FilterPT1";
import FilterPC1 from "../components/common/filters/pc1/FilterPC1";
import FilterMonAn from "../components/common/filters/monan/FilterMonAn";
import FilterNhomMon from "../components/common/filters/nhommon/FilterNhomMon";
import FilterPBLNH from "../components/common/filters/pbl-nh/FilterPBLNH";
import FilterDMBAN from "../components/common/filters/dmban/FilterDMBAN";
import FilterNhomBan from "../components/common/filters/nhomban/FilterNhomBan";
import FilterCustomer from "../components/common/filters/customer/FilterCustomer";
import FilterDMNHKH from "../components/common/filters/dmnhkh/FilterDMNHKH";
import FilterNCC from "../components/common/filters/ncc/FilterNCC";
import FilterDMNHNCC from "../components/common/filters/dmnhncc/FilterDMNHNCC";
import FilterUserGroup from "../components/common/filters/usergroup/FilterUserGroup";
import FilterParticipant from "../components/common/filters/participant/FilterParticipant";
import FilterDMDVT from "../components/common/filters/dmdvt/FilterDMDVT";
import FilterDMKHO from "../components/common/filters/dmkho/FilterDMKHO";
import FormRPT from "../components/common/form/rpt/FormRPT";
import FilterRPT from "../components/common/filters/rpt/FilterRPT";
import FormPtthanhtoan from "../components/common/form/ptthanhtoan/FormPtthanhtoan";
import FormDmChietKhau from "../components/common/form/dmchietkhau/FormDmChietKhau";
import FilterDmChietKhau from "../components/common/filters/dmchietkhau/FilterDmChietKhau";

const categories: { [key: string]: CategoryType } = {
  // Siêu thị
  hanghoa: {
    apiCode: "dmvt",
    title: "Danh sách hàng hóa",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    condition: {
      sp_yeu_cau_pha_che: { $ne: true },
      sp_yeu_cau_che_bien: { $ne: true },
    },
    Form: FormHangHoa,
    Filter: FilterHangHoa,
    Expand: ExpandHangHoa,
    // Filter: FilterDMNHAXE,
    columns: [
      {
        name: "Ảnh",
        width: "80px",
        cell: (row) => {
          return (
            <Tooltip
              placement="right"
              title={
                <Box
                  sx={{ width: "180px", height: "180px", borderRadius: "4px" }}
                >
                  <Avatar
                    src={
                      row.picture_thumb
                        ? generateLinkImage(row.picture_thumb)
                        : "/product.png"
                    }
                    imgProps={{ loading: "lazy" }}
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
              }
              slotProps={{
                popper: { disablePortal: true, sx: { zIndex: 10 } },
                tooltip: {
                  sx: {
                    padding: 0,
                    marginTop: "2px !important",
                    backgroundColor: "common.white",
                    boxShadow: "0px 2px 5px 0px #00000033",
                    color: "initial",
                  },
                },
              }}
            >
              <Avatar
                src={
                  row.picture_thumb
                    ? generateLinkImage(row.picture_thumb)
                    : "/product.png"
                }
                alt={row.ten_vt}
                sx={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "10px",
                  border: "1px dashed",
                  borderColor: "primary.main",
                }}
              />
            </Tooltip>
          );
        },
      },
      {
        name: "Mã hàng",
        width: "150px",
        selector: (row) => row.ma_vt,
        wrap: true,
      },
      {
        name: "Tên hàng",
        width: "200px",
        selector: (row) => row.ten_vt,
        wrap: true,
      },
      {
        name: "Đơn vị tính",
        width: "150px",
        selector: (row) => row.ten_dvt,
        wrap: true,
      },
      {
        name: "Nhóm hàng",
        width: "200px",
        selector: (row) => row.ten_nvt,
      },
      {
        name: "Giá bán",
        width: "150px",
        selector: (row) => row.gia_ban_le,
        format: (row) => numeralCustom(row.gia_ban_le).format(),
      },
      {
        name: "Giá vốn",
        width: "150px",
        selector: (row) => row.gia_mua,
        format: (row) => numeralCustom(row.gia_mua).format(),
      },
      {
        name: "Tồn kho",
        width: "150px",
        selector: (row) => row.ton00,
        format: (row) => numeralCustom(row.ton00).format(),
      },
    ],
  },
  nhomhang: {
    apiCode: "dmnvt",
    title: "Nhóm hàng",
    condition: { la_nhom_hang_hoa: true },
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormNhomHang,
    Filter: FilterNhomHang,
    columns: [
      {
        name: "Tên nhóm",
        width: "300px",
        wrap: true,
        selector: (row) => row.ten_nvt,
      },
      {
        name: "Nhóm mẹ",
        wrap: true,
        selector: (row) => row.ten_nh_me,
      },
    ],
  },
  dmqddvt: {
    apiCode: "dmqddvt",
    title: "Quy đổi đơn vị tính",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMQDDVT,
    Filter: FilterDMQDDVT,
    columns: [
      {
        name: "Hàng hóa",
        width: "300px",
        wrap: true,
        selector: (row) => `${row.ten_vt} (${row.ma_vt})`,
      },
      {
        name: "Đơn vị gốc",
        width: "120px",
        wrap: true,
        selector: (row) => row.ma_dvt_goc,
      },
      {
        name: "Đơn vị quy đổi",
        width: "150px",
        wrap: true,
        selector: (row) => row.ma_dvt,
      },
      {
        name: "SL quy đổi",
        width: "150px",
        wrap: true,
        selector: (row) => row.tu,
      },
      {
        name: "Giá bán",
        width: "120px",
        wrap: true,
        selector: (row) => row.gia_ban_nt,
        format: (row) => numeralCustom(row.gia_ban_nt).format(),
      },
    ],
  },
  cdvt: {
    apiCode: "cdvt",
    title: "Tồn đầu kỳ",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormCDVT,
    Filter: FilterCDVT,
    columns: [
      {
        name: "Năm",
        width: "80px",
        selector: (row) => row.nam,
      },
      {
        name: "Hàng hóa",
        width: "200px",
        wrap: true,
        selector: (row) => (row.ten_vt ? `${row.ten_vt} (${row.ma_vt})` : ""),
      },
      {
        name: "Chi nhánh",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Tồn đầu kỳ",
        width: "150px",
        wrap: true,
        selector: (row) => row.ton00,
      },
      {
        name: "Giá trị tồn",
        width: "150px",
        wrap: true,
        selector: (row) => row.du00,
        format: (row) => numeralCustom(row.du00).format(),
      },
    ],
  },
  pkk: {
    apiCode: "pkk",
    title: "Kiểm kê",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPKK,
    Expand: ExpandPkk,
    Filter: FilterPKK,
    columns: [
      {
        name: "Số CT",
        width: "100px",
        wrap: true,
        selector: (row) => row.so_ct,
      },
      {
        name: "Chi nhánh",
        width: "150px",
        selector: (row) => row.ten_kho,
      },
      {
        name: "Ngày chứng từ",
        width: "200px",
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Tổng tồn sổ sách",
        width: "180px",
        selector: (row) => row.t_sl_ton_ss,
      },
      {
        name: "Tổng tồn thực tế",
        width: "180px",
        selector: (row) => row.t_sl_ton_tt,
      },
      {
        name: "Tổng chênh lệch",
        width: "180px",
        selector: (row) => row.t_sl,
      },
    ],
  },
  pbl: {
    apiCode: "pbl",
    title: "Phiếu bán lẻ",
    allowCreate: false,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Expand: ExpandPBL,
    Filter: FilterPBL,
    renderInnerTop: () => {
      return (
        <>
          <Link to="/pos">
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{
                boxShadow: "none",
                color: "common.white",
                textTransform: "none",
                "&:hover": { boxShadow: "none" },
              }}
              startIcon={<LuPlusCircle size={16} />}
            >
              Thêm
            </Button>
          </Link>
        </>
      );
    },
    columns: [
      {
        name: "Số CT",
        width: "80px",
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "180px",
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Khách hàng",
        wrap: true,
        width: "120px",
        selector: (row) => row.ten_kh,
      },
      {
        name: "Nhân viên",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_nv,
      },
      {
        name: "Tổng tiền hàng",
        width: "180px",
        selector: (row) => row.t_tien_nt,
        format: (row) => numeralCustom(row.t_tien_nt).format(),
      },
      {
        name: "Tổng CK",
        width: "120px",
        selector: (row) => row.t_ck_nt,
        format: (row) => numeralCustom(row.t_ck_nt).format(),
      },
      {
        name: "Thành tiền",
        width: "120px",
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
      },
      {
        name: "PTTT",
        width: "180px",
        wrap: true,
        selector: (row) => row.ten_pt_thanh_toan,
      },
    ],
  },
  hd7: {
    apiCode: "hd7",
    title: "Trả hàng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormHD7,
    Expand: ExpandHD7,
    Filter: FilterHD7,
    columns: [
      {
        name: "Số CT",
        width: "80px",
        wrap: true,
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "160px",
        wrap: true,
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY - HH:mm"),
      },
      {
        name: "Khách hàng",
        width: "140px",
        wrap: true,
        selector: (row) => row.ten_kh,
      },
      {
        name: "Chi nhánh",
        width: "140px",
        wrap: true,
        selector: (row) => row.ten_kho || row.ma_kho,
      },
      {
        name: "Tổng tiền hàng",
        width: "180px",
        wrap: true,
        selector: (row) => row.t_tien_hang_nt,
        format: (row) => numeralCustom(row.t_tien_hang_nt).format(),
      },
      {
        name: "Tổng CK",
        width: "100px",
        wrap: true,
        selector: (row) => row.t_ck_nt,
        format: (row) => numeralCustom(row.t_ck_nt).format(),
      },
      {
        name: "Thành tiền",
        width: "150px",
        selector: (row) => row.t_tien_nhap_nt,
        format: (row) => numeralCustom(row.t_tien_nhap_nt).format(),
      },
    ],
  },
  pn1: {
    apiCode: "pn1",
    title: "Phiếu nhập hàng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPN1,
    Expand: ExpandPN1,
    Filter: FilterPN1,
    columns: [
      {
        name: "Số CT",
        width: "80px",
        wrap: true,
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "180px",
        wrap: true,
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Nhà cung cấp",
        width: "140px",
        wrap: true,
        selector: (row) => row.ten_kh,
      },
      {
        name: "Tiền hàng",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_tien_hang,
        format: (row) => numeralCustom(row.t_tien_hang).format(),
      },
      {
        name: "Tiền phí",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_cp_nt,
        format: (row) => numeralCustom(row.t_cp_nt).format(),
      },
      {
        name: "Tiền thuế",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_thue_vao_nt,
        format: (row) => numeralCustom(row.t_thue_vao_nt).format(),
      },
      {
        name: "Tiền nhập",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
      },
    ],
  },
  pn5: {
    apiCode: "pn5",
    title: "Phiếu trả hàng nhập",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPN5,
    Expand: ExpandPN5,
    Filter: FilterPN5,
    columns: [
      {
        name: "Số CT",
        selector: (row) => row.so_ct,
        width: "80px",
        wrap: true,
      },
      {
        name: "Ngày CT",
        width: "180px",
        wrap: true,
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        selector: (row) => row.ten_kho || row.ma_kho,
        width: "150px",
        wrap: true,
      },
      {
        name: "Nhà cung cấp",
        selector: (row) => row.ma_kh,
        width: "150px",
        wrap: true,
      },
      {
        name: "Tiền hàng",
        selector: (row) => row.t_tien_hang_nt,
        format: (row) => numeralCustom(row.t_tien_hang_nt).format(),
        width: "150px",
        wrap: true,
      },
      {
        name: "Tiền thuế",
        selector: (row) => row.t_thue_nt,
        format: (row) => numeralCustom(row.t_thue_nt).format(),
        width: "150px",
        wrap: true,
      },
      {
        name: "Tiền trả",
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
        width: "150px",
        wrap: true,
      },
    ],
  },
  pxk: {
    apiCode: "pxk",
    title: "Phiếu xuất hủy",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPXK,
    Expand: ExpandPXK,
    Filter: FilterPXK,
    columns: [
      {
        name: "Số CT",
        width: "100px",
        wrap: true,
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "160px",
        wrap: true,
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Nhà cung cấp",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_kh || row.ma_kh,
      },
      {
        name: "Tổng số lượng",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_sl,
      },
      {
        name: "Tiền hủy",
        width: "150px",
        wrap: true,
        selector: (row) => row.t_tien_xuat,
        format: (row) => numeralCustom(row.t_tien_xuat).format(),
      },
    ],
  },
  pt1: {
    apiCode: "pt1",
    title: "Phiếu thu",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPT1,
    Expand: ExpandPT1,
    Filter: FilterPT1,
    columns: [
      {
        name: "Số CT",
        width: "80px",
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "160px",
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "120px",
        selector: (row) => row.ten_kho,
      },
      {
        name: "Người nộp",
        width: "200px",
        wrap: true,
        selector: (row) => row.ten_kh,
      },
      {
        name: "Giá trị",
        width: "100px",
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
      },
      {
        name: "Ghi chú",
        wrap: true,
        selector: (row) => row.dien_giai,
      },
    ],
  },
  pc1: {
    apiCode: "pc1",
    title: "Phiếu chi",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPC1,
    Expand: ExpandPC1,
    Filter: FilterPC1,
    columns: [
      {
        name: "Số CT",
        width: "80px",
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "160px",
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "120px",
        selector: (row) => row.ten_kho,
      },
      {
        name: "Người nhận",
        selector: (row) => row.ten_kh,
        width: "200px",
        wrap: true,
      },
      {
        name: "Giá trị",
        width: "150px",
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
      },
      {
        name: "Ghi chú",
        wrap: true,
        selector: (row) => row.dien_giai,
      },
    ],
  },

  // Quán ăn
  monan: {
    apiCode: "dmvt",
    title: "Danh sách món",
    condition: {
      sp_yeu_cau_pha_che: true,
      sp_yeu_cau_che_bien: true,
    },
    allowCreate: true,
    allowFilter: true,
    fields: [
      { label: "Mã món", value: "ma_vt" },
      { label: "Tên món", value: "ten_vt" },
      { label: "Đơn vị tính", value: "ma_dvt" },
      { label: "Nhóm món", value: "ma_nvt" },
    ],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormMonAn,
    Expand: ExpandMonAn,
    Filter: FilterMonAn,
    columns: [
      {
        name: "Ảnh",
        width: "80px",
        cell: (row) => {
          return (
            <Tooltip
              placement="right"
              title={
                <Box
                  sx={{ width: "180px", height: "180px", borderRadius: "4px" }}
                >
                  <Avatar
                    src={
                      row.picture_thumb
                        ? generateLinkImage(row.picture_thumb)
                        : "/product.png"
                    }
                    imgProps={{ loading: "lazy" }}
                    sx={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "4px",
                      "& img": {
                        objectFit: "contain",
                      },
                    }}
                  />
                </Box>
              }
              slotProps={{
                popper: { disablePortal: true, sx: { zIndex: 10 } },
                tooltip: {
                  sx: {
                    padding: 0,
                    marginTop: "2px !important",
                    backgroundColor: "common.white",
                    boxShadow: "0px 2px 5px 0px #00000033",
                    color: "initial",
                  },
                },
              }}
            >
              <Avatar
                src={
                  row.picture_thumb
                    ? generateLinkImage(row.picture_thumb)
                    : "/product.png"
                }
                alt={row.ten_vt}
                sx={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "10px",
                  border: "1px dashed",
                  borderColor: "primary.main",
                }}
              />
            </Tooltip>
          );
        },
      },
      {
        name: "Mã",
        width: "150px",
        selector: (row) => row.ma_vt,
        wrap: true,
      },
      {
        name: "Tên",
        width: "200px",
        selector: (row) => row.ten_vt,
        wrap: true,
      },
      {
        name: "Đơn vị tính",
        width: "150px",
        selector: (row) => row.ten_dvt,
        wrap: true,
      },
      {
        name: "Nhóm",
        width: "200px",
        selector: (row) => row.ten_nvt,
      },
      {
        name: "Giá bán",
        width: "150px",
        selector: (row) => row.gia_ban_le,
        format: (row) => numeralCustom(row.gia_ban_le).format(),
      },
      {
        name: "Giá vốn",
        width: "150px",
        selector: (row) => row.gia_mua,
        format: (row) => numeralCustom(row.gia_mua).format(),
      },
    ],
  },
  nhommon: {
    apiCode: "dmnvt",
    title: "Nhóm món",
    condition: { la_nhom_hang_hoa: false },
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormNhomMon,
    Filter: FilterNhomMon,
    columns: [
      {
        name: "Tên nhóm",
        width: "300px",
        wrap: true,
        selector: (row) => row.ten_nvt,
      },
      {
        name: "Nhóm mẹ",
        wrap: true,
        selector: (row) => row.ten_nh_me,
      },
    ],
  },
  hd_nh: {
    apiCode: "pbl_nh",
    title: "Đơn hàng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPBLNH,
    Expand: ExpandPBLNH,
    Filter: FilterPBLNH,
    columns: [
      {
        name: "Trạng thái",
        width: "120px",
        selector: (row) => row.ten_trang_thai,
        cell: (row) => {
          return (
            <Typography sx={{ color: row.color, fontWeight: 600 }}>
              {row.ten_trang_thai}
            </Typography>
          );
        },
      },
      {
        name: "Số CT",
        width: "80px",
        selector: (row) => row.so_ct,
      },
      {
        name: "Ngày CT",
        width: "180px",
        selector: (row) => row.ngay_ct,
        format: (row) => formatDateDisplay(row.ngay_ct, "DD/MM/YYYY HH:mm"),
      },
      {
        name: "Chi nhánh",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Bàn",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_ban || row.ma_ban,
      },
      {
        name: "Khách hàng",
        wrap: true,
        width: "150px",
        selector: (row) => row.ten_kh,
      },
      {
        name: "Nhân viên",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_nv,
      },
      {
        name: "Tổng tiền hàng",
        width: "180px",
        selector: (row) => row.t_tien_nt,
        format: (row) => numeralCustom(row.t_tien_nt).format(),
      },
      {
        name: "Tổng CK",
        width: "120px",
        selector: (row) => row.t_ck_nt,
        format: (row) => numeralCustom(row.t_ck_nt).format(),
      },
      {
        name: "Thành tiền",
        width: "120px",
        selector: (row) => row.t_tt_nt,
        format: (row) => numeralCustom(row.t_tt_nt).format(),
      },
      {
        name: "PTTT",
        width: "180px",
        wrap: true,
        selector: (row) => row.ten_pt_thanh_toan,
      },
    ],
  },
  dmban: {
    apiCode: "dmban",
    title: "Phiếu ăn",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMBAN,
    Filter: FilterDMBAN,
    columns: [
      { name: "Số phiếu", width: "150px", selector: (row) => row.ten_ban },
      { name: "Chi nhánh", width: "150px", selector: (row) => row.ten_kho },
    ],
  },
  nhomban: {
    apiCode: "group",
    title: "Khu vực bàn",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    condition: { group_type: "TABLE" },
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormNHOMBAN,
    Filter: FilterNhomBan,
    columns: [
      {
        name: "Tên khu vực",
        selector: (row) => row.group_name,
      },
    ],
  },

  // đặt xe
  dmnhaxe: {
    apiCode: "dmnhaxe",
    title: "Nhà xe",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMNHAXE,
    Filter: FilterDMNHAXE,
    columns: [
      {
        name: "Mã nhà xe",
        width: "200px",
        wrap: true,
        selector: (row) => row.ma_dt,
      },
      {
        name: "Tên nhà xe",
        width: "200px",
        wrap: true,
        selector: (row) => row.ten_dt,
      },
    ],
  },
  dmloaixe: {
    apiCode: "dmloaixe",
    title: "Loại xe",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMLOAIXE,
    Filter: FilterDMLOAIXE,
    columns: [
      {
        name: "Loại xe",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Số ghế",
        width: "150px",
        wrap: true,
        selector: (row) => row.so_ghe,
      },
      {
        name: "Số tầng",
        width: "150px",
        wrap: true,
        selector: (row) => row.so_tang,
      },
      {
        name: "Số hàng",
        width: "150px",
        wrap: true,
        selector: (row) => row.so_hang,
      },
      {
        name: "Số dãy",
        width: "150px",
        wrap: true,
        selector: (row) => row.so_day,
      },
    ],
  },
  dmxe: {
    apiCode: "dmxe",
    title: "Xe khách",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMXE,
    Filter: FilterDMXE,
    columns: [
      {
        name: "Nhà xe",
        width: "200px",
        wrap: true,
        selector: (row) => row.ten_nha_xe || row.nha_xe,
      },
      {
        name: "Biển số",
        width: "150px",
        wrap: true,
        selector: (row) => row.bien_so,
      },
      {
        name: "Loại xe",
        width: "150px",
        wrap: true,
        selector: (row) => row.type_name,
      },
      {
        name: "Miêu tả",
        wrap: true,
        selector: (row) => row.mieu_ta,
      },
    ],
  },
  route: {
    apiCode: "route",
    title: "Tuyến đường",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormRoute,
    Filter: FilterRoute,
    columns: [
      {
        name: "Tên tuyến đường",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Điểm đi",
        width: "150px",
        wrap: true,
        selector: (row) => row.start,
      },
      {
        name: "Điểm đến",
        width: "150px",
        wrap: true,
        selector: (row) => row.end,
      },
      {
        name: "Khoảng cách",
        width: "130px",
        wrap: true,
        selector: (row) => row.distance,
      },
      {
        name: "Số giờ đi",
        width: "120px",
        wrap: true,
        selector: (row) => row.time,
      },
    ],
  },
  hangvexe: {
    apiCode: "hangvexe",
    title: "Hạng vé xe",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormHangVeXe,
    Filter: FilterHangVeXe,
    columns: [
      {
        name: "Mã",
        width: "150px",
        wrap: true,
        selector: (row) => row.ma,
      },
      {
        name: "Tên",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten,
      },
      {
        name: "Tuyến",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_tuyen,
      },
      {
        name: "Nhà xe",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_nhaxe,
      },
      {
        name: "Loại xe",
        width: "150px",
        wrap: true,
        selector: (row) => row.ten_loai_xe,
      },
      {
        name: "Giá vé",
        width: "150px",
        wrap: true,
        right: true,
        selector: (row) => row.gia_ve,
        format: (row) => numeralCustom(row.gia_ve).format(),
      },
      {
        name: "Hoa hồng (%)",
        width: "130px",
        wrap: true,
        right: true,
        selector: (row) => row.hoahong,
      },
    ],
  },
  ticketsorder: {
    apiCode: "vexe",
    title: "Danh sách vé",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormTicketOrder,
    Filter: FilterTicketOrder,
    columns: [
      {
        name: "Trạng thái",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_trang_thai,
        cell: (row) => {
          return (
            <Typography
              data-tag="allowRowEvents"
              sx={{
                fontWeight: 500,
                color: row.color,
              }}
            >
              {row.ten_trang_thai}
            </Typography>
          );
        },
      },
      {
        name: "Mã đặt chỗ",
        width: "120px",
        wrap: true,
        selector: (row) => row.ma,
      },
      {
        name: "Xe khách",
        width: "150px",
        wrap: true,
        selector: (row) => {
          return !!row.xe
            ? `${row?.ten_nha_xe}${row?.bien_so ? ` (${row?.bien_so})` : ""}`
            : "";
        },
      },
      {
        name: "Ngày đi",
        width: "120px",
        wrap: true,
        selector: (row) => row.tg_khoi_hanh,
        format: (row) => formatDateDisplay(row.tg_khoi_hanh, "DD/MM/YYYY"),
      },
      {
        name: "Giờ đi",
        width: "120px",
        wrap: true,
        selector: (row) => row.tg_khoi_hanh,
        format: (row) => formatDateDisplay(row.tg_khoi_hanh, "HH:mm"),
      },
      {
        name: "Tên khách",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_kh,
      },
      {
        name: "Ghế",
        width: "120px",
        wrap: true,
        selector: (row) => row.ma_ghe,
      },
      {
        name: "Tiền vé",
        width: "120px",
        wrap: true,
        selector: (row) => row.tien_tt_nt,
        format: (row) => numeralCustom(row.tien_tt_nt).format(),
      },
    ],
  },

  // Đối tác
  customer: {
    apiCode: "customer",
    title: "Danh sách khách hàng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    condition: { kh_yn: true },
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormCustomer,
    Filter: FilterCustomer,
    columns: [
      {
        name: "Mã",
        selector: (row) => row.ma_kh,
        width: "150px",
      },
      {
        name: "Tên",
        selector: (row) => row.ten_kh,
        width: "200px",
      },
      {
        name: "Email",
        selector: (row) => row.email,
        width: "200px",
      },
      {
        name: "Điện thoại",
        selector: (row) => row.dien_thoai,
        width: "120px",
      },
      {
        name: "Nhóm khách",
        selector: (row) => row.ten_nh_kh,
        width: "200px",
      },
      {
        name: "Ghi chú",
        selector: (row) => row.dien_giai,
        width: "200px",
      },
    ],
  },
  dmnhkh: {
    apiCode: "dmnhkh",
    title: "Nhóm khách",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMNHKH,
    Filter: FilterDMNHKH,
    columns: [
      {
        name: "Tên nhóm",
        selector: (row) => row.group_name,
      },
    ],
  },
  dmncc: {
    apiCode: "customer",
    title: "Danh sách nhà cung cấp",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    condition: { ncc_yn: true },
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormNCC,
    Filter: FilterNCC,
    columns: [
      {
        name: "Mã NCC",
        width: "130px",
        wrap: true,
        selector: (row) => row.ma_kh,
      },
      {
        name: "Tên NCC",
        width: "200px",
        wrap: true,
        selector: (row) => row.ten_kh,
      },
      {
        name: "Số điện thoại",
        width: "140px",
        selector: (row) => row.dien_thoai,
      },
      {
        name: "Email",
        width: "140px",
        wrap: true,
        selector: (row) => row.email,
      },
      {
        name: "Mã số thuế",
        width: "120px",
        wrap: true,
        selector: (row) => row.ma_so_thue,
      },
      {
        name: "Nhóm NCC",
        width: "120px",
        wrap: true,
        selector: (row) => row.ten_nh_kh,
      },
      {
        name: "Địa chỉ",
        width: "120px",
        wrap: true,
        selector: (row) => row.dia_chi,
      },
    ],
  },
  dmnhncc: {
    apiCode: "dmnhncc",
    title: "Nhóm nhà cung cấp",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMNHNCC,
    Filter: FilterDMNHNCC,
    columns: [
      {
        name: "Tên nhóm",
        selector: (row) => row.group_name,
      },
    ],
  },

  // chính sách giá
  dmchietkhau: {
    apiCode: "dmchietkhau",
    title: "Chiết khấu sản phẩm",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDmChietKhau,
    Filter: FilterDmChietKhau,
    columns: [
      {
        name: "Mã CK",
        width: "120px",
        selector: (row) => row.ma_chietkhau,
      },
      {
        name: "Tên CK",
        width: "130px",
        wrap: true,
        selector: (row) => row.ten_chietkhau,
      },
      {
        name: "Từ ngày",
        width: "130px",
        wrap: true,
        selector: (row) => row.hieu_luc_tu,
        format: (row) => formatDateDisplay(row.hieu_luc_tu),
      },
      {
        name: "Đến ngày",
        width: "130px",
        wrap: true,
        selector: (row) => row.hieu_luc_den,
        format: (row) => formatDateDisplay(row.hieu_luc_den),
      },
      {
        name: "Sản phẩm",
        width: "200px",
        wrap: true,
        selector: (row) => `${row.ten_vt} (${row.ma_vt})`,
      },
      {
        name: "SL áp dụng",
        width: "120px",
        wrap: true,
        selector: (row) => row.sl_tu,
      },
      {
        name: "Tiền CK",
        width: "130px",
        wrap: true,
        selector: (row) => row.tien_ck,
        format: (row) => numeralCustom(row.tien_ck).format(),
      },
    ],
  },

  // Hệ thống
  usergroup: {
    apiCode: "usergroup",
    title: "Nhóm người dùng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormUsergroup,
    Filter: FilterUserGroup,
    Expand: ExpandUsergroup,
    columns: [
      {
        name: "Tên nhóm",
        width: "200px",
        wrap: true,
        selector: (row) => row.group_name,
      },
    ],
  },
  participant: {
    apiCode: "participant",
    title: "Người dùng",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormParticipant,
    Filter: FilterParticipant,
    columns: [
      {
        name: "Tài khoản",
        width: "200px",
        wrap: true,
        selector: (row) => row.email,
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.name,
      },
      {
        name: "Nhóm",
        width: "140px",
        wrap: true,
        selector: (row) => row.group_name,
      },
      {
        name: "Quản trị viên",
        width: "200px",
        wrap: true,
        selector: (row) => row.admin,
        cell: (row) => {
          return (
            <CheckboxInput
              checked={row.admin}
              readOnly
              wrapperSx={{ display: "flex", justifyContent: "center" }}
            />
          );
        },
      },
    ],
  },
  dmdvt: {
    apiCode: "dmdvt",
    title: "Đơn vị tính",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDMDVT,
    Filter: FilterDMDVT,
    columns: [
      {
        name: "Tên đơn vị tính",
        selector: (row) => row.ten_dvt,
      },
    ],
  },
  ptthanhtoan: {
    apiCode: "ptthanhtoan",
    title: "Phương thức thanh toán",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormPtthanhtoan,
    columns: [
      {
        name: "Tên",
        selector: (row) => row.ten,
      },
    ],
  },
  dmkho: {
    apiCode: "dmkho",
    title: "Chi nhánh",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormDmKho,
    Filter: FilterDMKHO,
    columns: [
      {
        name: "Mã",
        width: "120px",
        wrap: true,
        selector: (row) => row.ma_kho,
      },
      {
        name: "Tên",
        width: "200px",
        wrap: true,
        selector: (row) => row.ten_kho,
      },
      {
        name: "Địa chỉ",
        width: "200px",
        wrap: true,
        selector: (row) => row.dia_chi,
      },
      {
        name: "Điện thoại",
        width: "150px",
        wrap: true,
        selector: (row) => row.exfields?.dien_thoai,
      },
      {
        name: "Email",
        width: "200px",
        wrap: true,
        selector: (row) => row.exfields?.email,
      },
    ],
  },
  rpt: {
    apiCode: "rpt",
    title: "Mẫu in",
    allowCreate: true,
    allowFilter: true,
    fields: [],
    showActions: true,
    showOptions: true,
    selectableRows: true,
    Form: FormRPT,
    Filter: FilterRPT,
    columns: [
      {
        name: "Mã CN",
        selector: (row) => row.ma_cn,
        width: "200px",
      },
      {
        name: "Tên mẫu in",
        selector: (row) => row.ten_mau_in,
      },
    ],
  },
};
export { categories };
